import type { NewsWidgetActions } from 'src/store/actions/widgets/news';
import type { NewsWidgetViewModel, WidgetTabViewModel } from 'src/store/types';

export const newsReducer = (
    state: WidgetTabViewModel<NewsWidgetViewModel>,
    action: NewsWidgetActions,
): WidgetTabViewModel<NewsWidgetViewModel> => {
    switch (action.type) {
        case 'userSetNewsColumns':
            return { ...state, widget: { ...state.widget, columns: action.columns } };
        case 'userSetNewsStrategy': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    ideas: action.ideas,
                },
            };
        }

        case 'userSetNewsUniverse': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    universeId: action.universeId,
                },
            };
        }

        case 'userSetNewsSymbolFilter':
        case 'updateNewsSymbolFilter': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    symbolFilter: action.symbol,
                },
            };
        }

        case 'userSetNewsSymbolRetention': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    symbolRetention: action.symbolRetention,
                },
            };
        }

        default:
            return state;
    }
};
